import React from 'react';

import { PageTitle } from '../../Text';

export default () => (
  <div className="primary-content">
    <PageTitle>
      CPCS Category
    </PageTitle>
    <p>
      Select the category(ies) and endorsement codes you do wish to renew. If you wish to renew all the categories and endorsements for which you are entitled to, select the All Categories and Endorsements section.
    </p>
  </div>
);
